import { Box, Stack, Typography } from "@mui/material";
import iconCalendar from '../../../assets/icons/iconCalendar.png';
import iconColorPalette from '../../../assets/icons/iconColorPalette.png';
import iconFolder from '../../../assets/icons/iconFolder.png';
import iconRocket from '../../../assets/icons/iconRocket.png';
import useStyles from './styles';

interface PropsMenuHome {
  onSelect: number;
  onMenuSelect: (valueMenu: number) => void;
} 

export function MenuHome({
  onSelect,
  onMenuSelect
}: PropsMenuHome) {
  const classes: any = useStyles();

  return (
    <Stack direction={'row'} spacing={2} className={classes.menuStudio}>

        <Box 
          className={classes.buttonMenu}
          sx={{
            ...(onSelect === 0 && {
              background: 'rgba(255, 255, 255, 0.3)',
              border: 'solid 1px #FFFFFF'
            })
          }}
          onClick={() => onMenuSelect(0)}
        >
          <img src={iconColorPalette} alt="studio" />  
          <Typography className={classes.typographyMenu}>
            Estúdio de Criação
          </Typography>
        </Box>
      
        <Box 
          className={classes.buttonMenu}
          sx={{
            ...(onSelect === 1 && {
              background: 'rgba(255, 255, 255, 0.3)',
              border: 'solid 1px #FFFFFF'
            })
          }}
          onClick={() => onMenuSelect(1)}
        >
          <img src={iconRocket} alt="modelos_profissionais" />
          <Typography className={classes.typographyMenu}>
            Modelos profissionais
          </Typography>
        </Box>
      
        <Box 
          className={classes.buttonMenu}
          sx={{
            ...(onSelect === 2 && {
              background: 'rgba(255, 255, 255, 0.3)',
              border: 'solid 1px #FFFFFF'
            })
          }}
          onClick={() => onMenuSelect(2)}
        >
          <img src={iconFolder} alt="meus_projetos" />
          <Typography className={classes.typographyMenu}>
            Meus projetos
          </Typography>
        </Box>
      
        <Box 
          className={classes.buttonMenu}
          sx={{
            ...(onSelect === 3 && {
              background: 'rgba(255, 255, 255, 0.3)',
              border: 'solid 1px #FFFFFF'
            })
          }}
          onClick={() => onMenuSelect(3)}
        >
          <img src={iconCalendar} alt="calendario" />
          <Typography className={classes.typographyMenu}>
            Calendário
          </Typography>
        </Box>
    
    </Stack>
  );
}